<div class="page-container">
  <div class="header">
    <h1>Deine Ordner</h1>
    <app-button *ngIf="courses?.length! > 0" [text]="'Ordner hinzufügen'" [leftIcon]="'fa-plus'" [size]="'small'" [style]="'outlined'" (clickEvent)="addCourse()"></app-button>
  </div>

  <app-add-item-widget *ngIf="courses?.length === 0" [message]="'courses.add_course_message' | translate" [buttonText]="'courses.add_course' | translate" (buttonClicked)="addCourse()"></app-add-item-widget>
  
  <div class="courses-list">
    <app-loader *ngIf="!courses" [text]="'courses.loading_courses' | translate"></app-loader>
    <app-courses-list *ngIf="courses && courses!.length > 0" [courses]="courses!" (courseClicked)="openCourse($event)"></app-courses-list>
  </div>

  <app-add-button [text]="'Ordner hinzufügen'" [footerIsVisible]="true" (clickEvent)="addCourse()"></app-add-button>
  
  <app-bottom-dialog [isVisible]="createCourse" [title]="'Ordner hinzufügen'" (actionCancelled)="createCourse = false">
    <app-create-course *ngIf="createCourse" (courseCreationFinished)="courseCreated()"></app-create-course>
  </app-bottom-dialog>
</div>